import {Box, FormControl, InputLabel, MenuItem, Typography} from "@mui/material";
import Select, {SelectChangeEvent} from '@mui/material/Select';
import React, {useState} from "react";
import View from "../../components/View";
import Page from "../../components/Page";
import formulas from "../../services/formulas";

const END = () => {

    const {calcEnd} = formulas();

    const [he, setHe] = useState(40);
    const [depth, setDepth] = useState(60);
    const [end, setEnd] = useState(calcEnd(40, 60));

    const changeHe = (event: SelectChangeEvent) => {
        const value = parseFloat(event.target.value);
        setHe(value)
        setEnd(calcEnd(value, depth))
    }

    const changeDepth = (event: SelectChangeEvent) => {
        const value = parseInt(event.target.value);
        setDepth(value)
        setEnd(calcEnd(he, value));
    }

    // @ts-ignore
    return (
        <Page>
            <View>
                <Typography variant="h6" sx={{mt: 1, mb: 1}}>Equivalent Narcotic Depth</Typography>
                <Typography variant="h6"><Box component="span" sx={{border: '1px solid grey', p: 1}}>{end.toFixed(0)}</Box>  Meters</Typography>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="Helium">Helium</InputLabel>
                    <Select
                        labelId="Helium"
                        id="Helium"
                        value={he.toString()}
                        label="Helium"
                        onChange={changeHe}
                    >
                        {[...Array(99)].map((x, i) => (
                            <MenuItem key={'he' + i} value={21 + i}>{21 + i}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="depth">Depth</InputLabel>
                    <Select
                        labelId="depth"
                        id="depth"
                        value={depth.toString()}
                        label="Depth"
                        onChange={changeDepth}
                    >
                        {[...Array(400)].map((x, i: number) => (
                            <MenuItem key={'d' +i} value={1 + i}>{1 + i}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </View>
            <View>
                <Typography style={{fontWeight: 'bold'}}>Equivalent Narcotic Depth (END)</Typography>
                <Typography style={{marginTop: 10}}>
                    Used in technical diving as a way of estimating the narcotic effect of a breathing
                    gas mixture, such as heliox and trimix. The method is, for a given mix and depth,
                    to calculate the depth which would produce the same narcotic effect when breathing
                    air.
                </Typography>
            </View>
        </Page>
    );
}

export default END;